import { useMutation, useQueryClient } from '@tanstack/react-query';
import { brgsApi } from '../api/brgs';
import { CreateBrgRequest, UpdateBrgRequest, BrgDetailDto } from '../types';

export function useCreateBrg() {
  const queryClient = useQueryClient();
  return useMutation<BrgDetailDto, Error, CreateBrgRequest>({
    mutationFn: (data) => brgsApi.create(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['brgs'] });
    },
  });
}

export function useUpdateBrg(id: string) {
  const queryClient = useQueryClient();
  return useMutation<BrgDetailDto, Error, UpdateBrgRequest>({
    mutationFn: (data) => brgsApi.update(id, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['brgs'] });
    },
  });
}

export function useInactivateBrg() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) => brgsApi.inactivate(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['brgs'] });
    },
  });
}

export function useDeleteBrg() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) => brgsApi.delete(id),
    onSuccess: () => {
      // Invalidate all cascade-deleted data when a BRG is deleted
      // Primary
      void queryClient.invalidateQueries({ queryKey: ['brgs'] });
      
      // Goals cascade-delete
      void queryClient.invalidateQueries({ queryKey: ['goals'] });
      
      // Projects cascade-delete
      void queryClient.invalidateQueries({ queryKey: ['projects'] });
      
      // Recognition cascade-delete (MmRecognitions table)
      void queryClient.invalidateQueries({ queryKey: ['recognitions'] });
      void queryClient.invalidateQueries({ queryKey: ['recognition'] });
      void queryClient.invalidateQueries({ queryKey: ['recognitionStats'] });
    },
  });
}
